/**
 * Centralized category definitions for all Bill Summary components
 * This ensures Sum Analysis and individual summaries use the same categories
 */

export const CUT_FILL_CATEGORIES = {
  "Site Clearance": [
    "vegStrip",
    "topsoilStrip",
  ],
  "Cut & Fill": [
    "cutFounds",
    "fillFounds",
    "cutPaths",
    "fillPaths",
    "cutGarden",
    "fillGarden",
    "cutDrives",
    "fillDrives",
    "fillToMakeUp6F2",
  ],
};

export const FOUNDATION_CATEGORIES = {
  "Excavate & Concrete": [
    "pileMat",
    "pileMatRemoval",
    "plotGarSetOut",
    "pileSetOut",
    "pileAttendance",
    "excavateTrench",
    "excavatePiled",
    "excavateVibro",
    "levelCompact",
    "stockpileArisings",
    "concreteBlinding",
    "formplasOrSimilar",
    "cropPiles",
    "fillSteelPiles",
    "rebar",
    "stepsInFounds",
    "meshReinforcement",
    "gen1ConcreteToStrip",
    "rc35ConcreteToPiled",
    "rc35ConcreteToVibro",
    "stripClaymaster",
    "piledClaymaster",
  ],
  Substructure: [
    "trench4NBlock300mmWide",
    "trench7NBlock300mmWide",
    "trench4NBlock355mmWide",
    "trench7NBlock355mmWide",
    "dense4NBlockwork100mm",
    "dense7NBlockwork100mm",
    "dense10NBlockwork100mm",
    "aerated4NBlockwork100mm",
    "aerated7NBlockwork100mm",
    "aerated4NBlockwork140mm",
    "aerated7NBlockwork140mm",
    "dense100mmCoursingBrick",
    "aerated100mmCoursingBrick",
    "aerated140mmCoursingBrick",
    "layFacingBrickwork",
    "supplyFacingBrickwork",
    "beamInfill",
    "formCavity",
    "cavityFill",
    "telescopicVents",
    "telescopicVents140",
    "perimeterInsulation",
    "perimeterInsulation30",
    "dpc100mm",
    "backfillExcavations",
    "cavityInsulation",
  ],
  Abnormals: [
    "additionalExcavation",
    "gen1AdditionalConcrete",
    "additional300mmTrenchBlock",
    "additional355mmTrenchBlock",
    "additional100mmBlockwork",
    "backfillExcavationsAsDug",
    "depositOnSite",
    "eoExposedBrickwork",
    "eoTanking",
    "depositCFAArisings",
    "pileCollar",
    "cordekCellcore155",
    "cordekCellcore225",
  ],
  Floors: [
    "bbFloorHouse",
    "bbFloorGarage",
    "layOnlyFloors",
    "insituFloorHouse",
    "topHats",
    "eo2000gDPM",
    "eoAmber1DPM",
    "eoAmber2DPM",
    "radonMembrane",
    "gasMembrane",
    "meshToFloor",
    "topLayerMesh",
    "insituFloorGarage",
    "meshToGarageFloor",
  ],
};

export const PLOT_DRIVES_CATEGORIES = {
  // DRIVES TO BINDER - Private Drives
  "Private Macadam - Drives to Binder": [
    "macadamLevelCompact",
    "macadamGeotextileLayer",
    "macadamSubBase",
    "macadamDbBase",
    "macadamDbBinder",
    "macadamSealingGrit",
  ],
  "Private Block Paved - Drives to Binder": [
    "blockLevelCompact",
    "blockGeotextileLayer",
    "block300mmAdditionalCapping",
    "block250mmSubBase",
    "block100mmDbBase",
    "blockDbBinder",
    "blockSealingGrit",
  ],
  "Private Permeable - Drives to Binder": [
    "permeableLevelCompact",
    "permeableImpermeableGeotextileLayer",
    "permeableDbBinderRunningCourse",
    "permeable10to63mmCleanAggregateSubBase",
    "permeable5to20mmCleanAggregateSubBase",
    "permeableGeotextileLayer",
  ],
  // DRIVES TO BINDER - Shared Drives
  "Shared Macadam - Drives to Binder": [
    "sharedMacadamLevelCompact",
    "sharedMacadamGeotextileLayer",
    "sharedMacadamSubBase",
    "sharedMacadamDbBase",
    "sharedMacadamDbBinder",
    "sharedMacadamSealingGrit",
  ],
  "Shared Block Paved - Drives to Binder": [
    "sharedBlockLevelCompact",
    "sharedBlockGeotextileLayer",
    "sharedBlockSubBase",
    "sharedBlockBase",
    "sharedBlockBinder",
    "sharedBlockSealingGrit",
  ],
  "Shared Permeable - Drives to Binder": [
    "sharedPermeableLevelCompact",
    "sharedPermeableImpermeableGeotextileLayer",
    "sharedPermeableDbBinderRunningCourse",
    "sharedPermeable10to63mmCleanAggregateSubBase",
    "sharedPermeable5to20mmCleanAggregateSubBase",
    "sharedPermeableGeotextileLayer",
  ],
  // KERBS AND EDGINGS (Binder tab - Kerbs and Edgings section)
  "Edgings & Kerbs": [
    "sharedPermeable150x50mmPccEdgings",
    "sharedPermeable200x50mmPccEdgings",
    "sharedPermeableTimberEdgings",
    "sharedPermablePccKerbs",
    "sharedPermeableKerbType1",
    "sharedPermeableKerbType2",
    "sharedPermeableKerbType3",
    "sharedPermeableKeyKerb",
    "sharedPermeableRecessedCF",
  ],
  // DRIVES SURFACE COURSE - Private Drives
  "Private Macadam - Surface Course": [
    "macadamRemoveTimberEdgings",
    "macadamTack",
    "macadamDbSurfaceCourse",
    "macadamHraSurfaceCourse",
    "macadamSmaSurfaceCourse",
  ],
  "Private Block Paved - Surface Course": [
    "blockSweep",
    "blockPunctureMacadam",
    "blockLayingCourse",
    "block60mmConcrete",
    "block80mmConcrete",
  ],
  "Private Permeable - Surface Course": [
    "permeablePunctureMacadam",
    "permeable2to6mmLayingAggregate",
    "permeable60mmConcrete",
    "permeable80mmConcrete",
  ],
  // DRIVES SURFACE COURSE - Shared Drives
  "Shared Macadam - Surface Course": [
    "sharedMacadamSweepTack",
    "sharedMacadamDbSurfaceCourse",
    "sharedMacadamHraSurfaceCourse",
    "sharedMacadamSmaSurfaceCourse",
  ],
  "Shared Block Paved - Surface Course": [
    "sharedBlockPunctureMacadam",
    "sharedBlockLayingCourse",
    "sharedBlock60mmConcrete",
    "sharedBlock80mmConcrete",
  ],
  "Shared Permeable - Surface Course": [
    "sharedPermeablePunctureMacadam",
    "sharedPermeable2to6mmLayingAggregate",
    "sharedPermeable60mmConcrete",
    "sharedPermeable80mmConcrete",
  ],
  // ANCILLARY ITEMS (Surface tab - Ancillary Items section)
  "Ancillary Items": [
    "sharedPermeableAdjustIronwork",
    "sharedPermeableDriveDemo",
    "sharedPermeableEdgingRemedials",
    "sharedPermeableKerbRemedials",
  ],
};

export const DRAINAGE_CATEGORIES = {
  "Plot Foul Drainage": [
    "osma32mmBend", // Lab per Plot
  ],
  "Storm Plot Drainage": [
    "osmaStorm32mmBend", // Lab per Plot
  ],
  "POLYPIPE - FOUL": [
    "polypipe32mmBend", // Lab per Plot
  ],
  "POLYPIPE - STORM": [
    "polypipeStorm32mmBend", // Lab per Plot
  ],
};

export const PLOT_SERVICE_CATEGORIES = {
  "Plot Services": ["plots"],
  "Service Connections": ["serviceConnectionPlots"],
};

export const SERVICE_CONNECTIONS_CATEGORIES = {
  "Service Connection": ["serviceConnectionPlots"],
};

export const PLOT_PAVINGS_CATEGORIES = {
  "Paving Paths": [
    "pavingLevelCompact",
    "pavingGeotextileLayer",
    "pavingSubBase",
    "pavingPlainGreyPavings",
    "slab900wSteps",
    "slab1200wSteps",
    "slabGravelMarginPea",
    "slabGravelMarginCotswold",
    "slabThresholdDrain",
    "slabShedBase",
    "slabCycleHoops",
    "slabRotaryDryer",
  ],
  "Macadam Paths": [
    "macadamLevelCompact",
    "macadamGeotextileLayer",
    "macadamSubBase",
    "macadamDbBase",
    "macadamDbBinder",
    "macadamSealingGrit",
    "macadamSweepTack",
    "macadamDbSurfaceCourse",
    "macadamHraSurfaceCourse",
    "macadamSmaSurfaceCourse",
    "macadamEdgings",
  ],
};

export const SCAFFOLD_CATEGORIES = {
  "Scaffold Platforms": [
    "scaffoldPlatform",
    "scaffoldLevelCompact",
    "scaffoldGeotextileLayer",
    "scaffoldCrush6F2",
    "scaffoldType1",
  ],
  "Loading Bays": [
    "loadingBay4x2m",
    "loadingLevelCompact",
    "loadingGeotextileLayer",
    "loadingCrush6F2",
    "loadingType1",
  ],
  "Stair Access": [
    "stairAccess3x3m",
    "stairLevelCompact",
    "stairGeotextileLayer",
    "stairCrush6F2",
    "stairType1",
  ],
};

export const GARDEN_CATEGORIES = {
  "Ground Preparation": [
    // `scaffoldPlatform` was previously listed here too, which caused
    // `calculateGardenGrandTotal` to double-count the field (it's already
    // multiplied through `calculateScaffoldGrandTotal`'s consolidation as
    // the platform-quantity multiplier). Removed so Plot Matrix grand total
    // reconciles with Sum Analysis grand total — the BoQ Garden Bill Summary
    // is the only consumer of GARDEN_CATEGORIES, and Garden Bill Summary
    // shouldn't list scaffold platforms in any case.
    "thickNoDigLayer",
    "geotextileLayer",
    "plotClearance",
  ],
  "Subsoil Works": [
    "spreadLevelCleanSubsoilCapSiteWon",
    "spreadLevelCleanSubsoilCapImported",
  ],
  "Topsoil & Finishing": [
    "harrowGardens",
    "spreadLevelTopsoilSiteWon",
    "spreadLevelTopsoilImported",
  ],
};

export const RET_SCREEN_WALLS_CATEGORIES = {
  "Screen Walls": ["screenWalls"],
  "Screen Walls EO Pillar": ["screenWallsEO"],
  "Screen Walls Sof 450mm": ["screenWallsSof"],
  "Screen Walls Log 1200mm": ["screenWallsLog"],
  "Screen Walls Gravel Board": ["screenWallsGravelBoard"],
  "Screen Walls Additional Excavation": ["screenWallsAdditionalExcavation"],
  "Screen Walls Additional Concrete": ["screenWallsAdditionalConcrete"],
  "Garden Retaining Walls": [
    "grw450",
    "grw600",
    "grw750",
    "grw900",
    "grw1050",
    "grw1200",
    "grw1500",
    "grw1800",
    "grw2000",
  ],
  "Concrete Core Walls": [
    "ccrw1500",
    "ccrw1800",
    "ccrw2000",
    "ccrw2250",
    "ccrw2500",
    "ccrw2750",
    "ccrw3000",
    "ccrw3250",
    "ccrw3500",
  ],
  "Drive Retaining Walls": [
    "drw450",
    "drw600",
    "drw750",
    "drw900",
    "drw1050",
    "drw1200",
    "drw1500",
    "drw1800",
    "drw2000",
    "drw2250",
    "drw2500",
    "drw2750",
    "drw3000",
  ],
};

export const GEO_TOBER_WALL_CATEGORIES = {
  "GEOWALLS - Excavation & Foundation": [
    "excavateTrenchAndTipOnSite",
    "compactFormation",
    "concreteBlinding",
    "a393Mesh",
    "a252Mesh",
    "b503Mesh",
    "b785Mesh",
    "concreteToFoundation",
  ],
  "GEOWALLS - Backfill & Drainage": [
    "asDugBackfill",
    "stockpileOnsite",
    "perforated150mmPipe",
    "concreteHaunchingToFront",
    "concreteHaunchingToRear",
    "granularBackfill",
    "granularBackfill2",
    "terram",
  ],
  "GEOWALLS - Installation": [
    "fencePostAt2400mmCcs",
    "purchaseInclCarriageWasteFp",
    "installGeoWalls",
  ],
  "TOBERMORE - Excavation & Preparation": [
    "excavateInCuttingsFp",
    "excavationOfEmbankment",
    "stockpileOnsiteTobermore",
    "batterToFaceOfEmbankment",
    "excavationOfBase",
    "stockpileOnsite2",
    "levelAndCompactFormation",
    "concreteToBase",
  ],
  "TOBERMORE - Wall Installation": [
    "tobermoreSupplyOfGrandSecuraInclFp",
    "tobermoreSecuraInstallationByMj",
    "tobermoreSupplyOfGeogrid",
    "mjInstallationOfGeogrid",
    "installGeoWallsTobermore",
    "fencePostAt2400mmCcsTobermore",
  ],
  "TOBERMORE - Backfill & Drainage": [
    "freeDrainingGranularBackfill300wColumn",
    "granularBackfillToRearOfWall",
    "landDrainToRearOfWall",
    "allowSiltTrap",
    "allowToConnectOfLandDrainToPlotDrainage",
  ],
};

// Map of step names to their categories
export const STEP_CATEGORIES: {
  [stepName: string]: { [categoryName: string]: string[] } | null;
} = {
  "Cut & Fills": CUT_FILL_CATEGORIES,
  Foundations: FOUNDATION_CATEGORIES,
  Scaffold: SCAFFOLD_CATEGORIES,
  Drainage: DRAINAGE_CATEGORIES,
  "Plot Service": PLOT_SERVICE_CATEGORIES,
  "Plot Drives": PLOT_DRIVES_CATEGORIES,
  "Ret & Screen Walls": RET_SCREEN_WALLS_CATEGORIES,
  "Service Connections": SERVICE_CONNECTIONS_CATEGORIES,
  "Plot Pavings": PLOT_PAVINGS_CATEGORIES,
  Garden: GARDEN_CATEGORIES,
  // 'Geowall & Tobermore Walls': GEO_TOBER_WALL_CATEGORIES, // Excluded - not required
};

// ==========================================
// PLOT MATRIX SPECIFIC CATEGORIES
// These are simplified/consolidated categories used only for Plot Matrix display
// ==========================================

// Split into separate categories for Plot Matrix ordering
// Valuation Stage 1: Site Strip
export const PLOT_MATRIX_SITE_STRIP_CATEGORIES = {
  "Site Strip - Site strip to remove vegetation": ["vegStrip"],
  "Site Strip - Excavate to strip topsoil, depth n.e. xxmm": ["topsoilStrip"],
  "Site Strip - Topsoil Disposal": [
    "topsoilDisposalOnsite",
    "topsoilDisposalOffsite",
  ],
};

// Valuation Stage 2: Cut/Fill
export const PLOT_MATRIX_CUT_FILL_CATEGORIES = {
  "Cut/Fill - Cut/Fill to Foundations": ["cutFounds", "fillFounds"],
  "Cut/Fill - Cut/Fill to Slab Paths": ["cutPaths", "fillPaths"],
  "Cut/Fill - Cut/Fill to Gardens": ["cutGarden", "fillGarden"],
  // `fillToMakeUp6F2` has been moved to `Private Drives to Binder - Sub Base`
  // per user request — it now lives only under that category in the Plot
  // Matrix. The BoQ Cut & Fill Bill Summary still buckets it as Drives via
  // `getColumnType` (any fieldName containing "6f2"), so the Plot Matrix
  // Cut/Fill column total will be short of the BoQ Cut & Fill section total
  // by the 6F2 amount — this is the accepted trade-off for the move.
  "Cut/Fill - Cut/Fill to Drives": ["cutDrives", "fillDrives"],
  "Cut/Fill - Disposal Of Surplus": [],
  "Cut/Fill - Import of Deficit": [],
};

// Valuation Stage 3: Pile Matts
export const PLOT_MATRIX_PILE_MATTS_CATEGORIES = {
  "Pile Matts - Install Pile Matt": ["pileMat"],
  "Pile Matts - Recover Pile Matt": ["pileMatRemoval"],
};

// Valuation Stage 4: Foundation - Exc & Conc
export const PLOT_MATRIX_FOUNDATION_EXC_CONC_CATEGORIES = {
  "Foundation Exc & Conc - Prelim Setting Out": [
    "plotGarSetOut",
    "pileSetOut",
    "pileAttendance",
  ],
  "Foundation Exc & Conc - Excavate Foundation": [
    "excavateTrench",
    "excavateVibro",
    "excavatePiled",
    "levelCompact",
    "depositOnSite",
    "stepsInFounds",
    // `stockpileArisings` ("Deposit on site (arisings)", code GWALP035) and
    // `additionalExcavation` were moved to the Plot Matrix "Uncategorized"
    // column (synthetic column injected in PlotMatrix.tsx with
    // `stepName: 'Foundations'`). Their BoQ amounts are still computed by
    // `computeFoundationsFieldBillSummaryData` via `FOUNDATION_CATEGORIES`
    // (Excavate & Concrete / Abnormals), so per-cell proportional
    // distribution simply moves from this column to Uncategorized — column
    // totals shift, grand total unchanged.
  ],
  "Foundation Exc & Conc - Pile Crop": ["cropPiles", "fillSteelPiles"],
  "Foundation Exc & Conc - Concrete Blinding": ["concreteBlinding"],
  "Foundation Exc & Conc - Heave Protection": [
    "stripClaymaster",
    "piledClaymaster",
    "depositCFAArisings",
    "pileCollar",
    "cordekCellcore155",
    "cordekCellcore225",
  ],
  "Foundation Exc & Conc - Place Steel/Mesh": ["rebar", "meshReinforcement"],
  "Foundation Exc & Conc - Formwork": ["formplasOrSimilar"],
  "Foundation Exc & Conc - Concrete": [
    "gen1ConcreteToStrip",
    "rc35ConcreteToPiled",
    "rc35ConcreteToVibro",
  ],
  // New "Abnormals" sub-column on the Plot Matrix "Foundation Exc & Conc"
  // valuation stage — sits alongside "Concrete" and aggregates every
  // field previously routed through the synthetic "Uncategorized"
  // column. Per-cell amount and column total are computed by the regular
  // Foundations dispatch in `generatePlotMatrixCategoryRows`
  // (`computeFoundationsCellAmount` → proportional Bill Summary share):
  // all eight fields remain in `FOUNDATION_CATEGORIES` (BoQ side) under
  // Excavate & Concrete / Abnormals / Floors, so per-cell distribution
  // is identical — just under this column's `dataIndex` now. With this
  // column in place, the synthetic Uncategorized column is no longer
  // injected anywhere; the `appendUncategorizedColumn` helper and the
  // multi-step Uncategorized dispatch are retained as dormant code for
  // any future cross-step field that needs a temporary home before
  // landing in a named BoQ sub-column.
  "Foundation Exc & Conc - Abnormals": [
    "stockpileArisings",        // BoQ: Excavate & Concrete — "Deposit on site"
    "additionalExcavation",     // BoQ: Abnormals
    "gen1AdditionalConcrete",   // BoQ: Abnormals — "Additional GEN 1 Concrete"
    "additional300mmTrenchBlock", // BoQ: Abnormals
    "additional355mmTrenchBlock", // BoQ: Abnormals
    "additional100mmBlockwork",   // BoQ: Abnormals
    "backfillExcavationsAsDug",   // BoQ: Abnormals
  ],
};

// Valuation Stage 5: Foundation - Walls to DPC
export const PLOT_MATRIX_FOUNDATION_WALLS_DPC_CATEGORIES = {
  "Foundations to DPC - Trench/Blockwork": [
    "trench4NBlock300mmWide", // SUBSTRUCTURE: Trench block 300mm wide 3.6N - Thermalite
    "trench7NBlock300mmWide", // SUBSTRUCTURE: Trench block 300mm wide 7.0N - Thermalite
    "trench4NBlock355mmWide", // SUBSTRUCTURE: Trench block 355mm wide 3.6N - Thermalite
    "trench7NBlock355mmWide", // SUBSTRUCTURE: Trench block 355mm wide 7.0N - Thermalite
    "dense4NBlockwork100mm", // SUBSTRUCTURE: 3.6N 100mm Dense Blockwork
    "dense7NBlockwork100mm", // SUBSTRUCTURE: Dense concrete blockwork 100 thk 7n/mm2 (Ext Leaf)
    "dense10NBlockwork100mm", // SUBSTRUCTURE: 10N 100mm Dense Blockwork
    "aerated4NBlockwork100mm",
    "aerated7NBlockwork100mm",
    "aerated4NBlockwork140mm", // SUBSTRUCTURE: Aerated concrete blockwork 140 thk 3.6n/mm2 - Thermalite
    "aerated7NBlockwork140mm", // SUBSTRUCTURE: Aerated concrete blockwork 140 thk 7n/mm2 - Thermalite
    "dense100mmCoursingBrick", // SUBSTRUCTURE: Dense HB Common Brickwork - 100mm
    "aerated100mmCoursingBrick", // SUBSTRUCTURE: Aerated HB Common Brickwork - 100mm - Thermalite
    "aerated140mmCoursingBrick", // SUBSTRUCTURE: Aerated HB Common Brickwork - 140mm - Thermalite
    "beamInfill", // SUBSTRUCTURE: T Closure (dense 100 wide)
    "formCavity", // SUBSTRUCTURE: Form cavity
    "cavityFill", // SUBSTRUCTURE: Cavity infill concrete
    "telescopicVents", // SUBSTRUCTURE: Telescopic vents (including lintel) - 100 wide
    "telescopicVents140", // SUBSTRUCTURE: Telescopic vents (including lintel) - 140 wide
    "perimeterInsulation", // SUBSTRUCTURE: 25mm Perimeter Strip
    "perimeterInsulation30", // SUBSTRUCTURE: 30mm Perimeter Strip
    "dpc100mm", // SUBSTRUCTURE: DPC 100mm wide
    "backfillExcavations", // SUBSTRUCTURE: Backfill with as dug
    "cavityInsulation", // SUBSTRUCTURE: Cavity insulation
    // The four Abnormals fields below were moved to the Plot Matrix
    // "Uncategorized" column (synthetic column in PlotMatrix.tsx with
    // `stepName: 'Foundations'`):
    //   - additional300mmTrenchBlock — "Additional 300mm Trench Block"
    //   - additional355mmTrenchBlock — "Additional 355mm Trench Block"
    //   - additional100mmBlockwork   — "Additional 7.2N Aerated 100mm Blockwork"
    //   - backfillExcavationsAsDug   — "Backfill excavations with as dug"
    // Their BoQ amounts are still computed by
    // `computeFoundationsFieldBillSummaryData` via
    // `FOUNDATION_CATEGORIES.Abnormals` (where they remain listed), so the
    // proportional Bill Summary share simply moves from this column to
    // Uncategorized — column totals shift, Foundations grand total
    // unchanged.
  ],
  "Foundations to DPC - Splash Course": [
    "layFacingBrickwork", // SUBSTRUCTURE: HB wall in facings FREE ISSUE - 215 x 102.5 x 65mm
    "supplyFacingBrickwork", // SUBSTRUCTURE: HB wall in Red Class B's (perf) M&J Supply - 215 x 102.5 x 65mm
  ],
  "Foundations to DPC - Floor Top Out": [
    "included"
  ],
  "Foundations to DPC - Exposed Splash": [
    "eoExposedBrickwork", // ABNORMALS: EO Exposed Brickwork (SUM ONLY ONE COLUMN)
  ],
  "Foundations to DPC - Tanking": [
    "eoTanking", // ABNORMALS: EO Tanking incl. retaining blockwork (SUM ONLY ONE COLUMN)
  ],
};

// Valuation Stage 6: Foundation Floor
export const PLOT_MATRIX_FOUNDATION_FLOOR_CATEGORIES = {
  "Foundation Floor - Beam Supply": [
    "bbFloorHouse", // Floors: B&B floor House
    "bbFloorGarage", // Floors: Garage - Beam and block
    "insituFloorHouse", // Floors: 150mm thick cast insitu suspended slab - houses
    "meshToFloor", // Floors: Mesh to floor
    "topLayerMesh", // Floors: Top layer Mesh
    "insituFloorGarage", // Floors: Cast Insitu Slab - Garages
    "meshToGarageFloor", // Floors: Mesh to Garage floor
  ],
  "Foundation Floor - Place Beams": [
    "layOnlyFloors", // Floors: Lay only Floors (SUM ONLY ONE COLUMN)
  ],
  "Foundation Floor - Membrane/DPM": [
    "topHats", // Floors: Top Hats
    "eo2000gDPM", // Floors: EO 2000g DPM
    "eoAmber1DPM", // Floors: EO Amber 1 DPM
    "eoAmber2DPM", // Floors: EO AMBER 2 DPM
    "radonMembrane", // Floors: Radon Membrane
    "gasMembrane", // Floors: Gas Membrane with validation
  ],
  "Foundation Floor - Topsheet": [
    "included"
  ],
  "Foundation Floor - Floor Concrete": [
    "included"
  ],
};

// Valuation Stage 7: Scaffold Platforms
export const PLOT_MATRIX_SCAFFOLD_CATEGORIES = {
  "Scaffold Platforms - Scaffold Platforms": [
    "scaffoldLevelCompact",
    "scaffoldGeotextileLayer",
    "scaffoldCrush6F2",
    "scaffoldType1",
  ],
  "Scaffold Platforms - Loading Bays": [
    "loadingLevelCompact",
    "loadingGeotextileLayer",
    "loadingCrush6F2",
    "loadingType1",
  ],
  "Scaffold Platforms - Removal": [
    "stairLevelCompact",
    "stairGeotextileLayer",
    "stairCrush6F2",
    "stairType1",
  ],
};

// Valuation Stage 8: Plot Drainage
export const PLOT_MATRIX_DRAINAGE_CATEGORIES = {
  "Plot Drainage - Foul": ["osma32mmBend", "polypipe32mmBend"],
  "Plot Drainage - Storm": ["osmaStorm32mmBend", "polypipeStorm32mmBend"],
};

// Valuation Stage 9: Plot Services
export const PLOT_MATRIX_PLOT_SERVICE_CATEGORIES = {
  "Plot Services - Plot Services": ["plots"],
};

// Valuation Stage 10 & 11: Private/Shared Drives to Binder
export const PLOT_MATRIX_PRIVATE_DRIVES_BINDER_CATEGORIES = {
  "Private Drives to Binder - Sub Base": [
    "fillToMakeUp6F2", // Cut Fills / Drives: Fill to make up levels with 6F2
    "macadamLevelCompact", // Private Macadam Drive: Level and compact formation
    "macadamGeotextileLayer", // Private Macadam Drive: Geotextile layer
    "macadamSubBase", // Private Macadam Drive: xxxmm thick MOT Type 1
    "blockLevelCompact", // Private Block Paved Drive: Level and compact formation
    "blockGeotextileLayer", // Private Block Paved Drive: Geotextile layer
    "block300mmAdditionalCapping", // Private Block Paved Drive: xxxmm thick MOT Type 1
    "permeableLevelCompact", // Permeable Paving: Level and compact formation
    "permeableImpermeableGeotextileLayer", // Permeable Paving: Terram Layer to Bottom and Sides permeable paving
    "permeable10to63mmCleanAggregateSubBase", // Permeable Paving: 63-10mm Sub Base - Varied Depths
    "permeable5to20mmCleanAggregateSubBase", // Permeable Paving: xxmm 5-20mm clean aggregate sub base
    "permeableGeotextileLayer", // Permeable Paving: Permeable geotextile membrane
  ],
  // "Private Drives to Binder - Timber Edgings" was removed from Plot
  // Matrix; its field `sharedPermeableTimberEdgings` (GWALP032 "Timber
  // Edgings") is now folded into the "Edgings & Kerbs" column below
  // (was briefly routed through the synthetic Uncategorized column —
  // moved here per user direction so it sits with the other kerb /
  // edging fields). The Plot Drives step dispatch handles it via the
  // existing `computePlotDrivesCellAmount` proportional Bill Summary
  // share — `PLOT_DRIVES_CATEGORIES["Edgings & Kerbs"]` already lists
  // the field, so the BoQ Plot Drives section total is unchanged.
  "Private Drives to Binder - Edgings & Kerbs": [
    "sharedPermeable150x50mmPccEdgings", // Kerbs and Edgings: 150x50mm PCC Edgings (col39)
    "sharedPermeable200x50mmPccEdgings", // Kerbs and Edgings: 200x50mm PCC Edgings (col40)
    "sharedPermeableTimberEdgings", // Kerbs and Edgings: Timber Edgings (col41, GWALP032)
    "sharedPermablePccKerbs", // Kerbs and Edgings: PCC Kerbs (col42)
    "sharedPermeableKerbType1", // Kerbs and Edgings: xxxx Kerb (col43)
    "sharedPermeableKerbType2", // Kerbs and Edgings: xxxx Kerb (col44)
    "sharedPermeableKerbType3", // Kerbs and Edgings: xxxx Kerb (col45)
    "sharedPermeableKeyKerb", // Kerbs and Edgings: Key Kerb (col46)
  ],
  "Private Drives to Binder - Binder Course": [
    "macadamDbBase", // Private Macadam Drive: xxmm DB Base (col4)
    "macadamDbBinder", // Private Macadam Drive: xxmm DB Binder (col5)
    "macadamSealingGrit", // Private Macadam Drive: Sealing Grit (col6)
    "block250mmSubBase", // Private Block Paved Drive: xxmm DB Base (col10)
    "block100mmDbBase", // Private Block Paved Drive: xxmm DB Binder (col11)
    "blockDbBinder", // Private Block Paved Drive: DB Binder (legacy field, kept for BoQ parity)
    "blockSealingGrit", // Private Block Paved Drive: Sealing Grit (col12)
    "permeableDbBinderRunningCourse", // Permeable Paving: xxmm DB binder Running course (col16)
  ],
};

export const PLOT_MATRIX_SHARED_DRIVES_BINDER_CATEGORIES = {
  "Shared Drives to Binder - Sub Base": [
    "sharedMacadamLevelCompact", // Shared Macadam Drive: Level and compact formation (col20)
    "sharedMacadamGeotextileLayer", // Shared Macadam Drive: Geotextile layer (col21)
    "sharedMacadamSubBase", // Shared Macadam Drive: xxxmm thick MOT Type 1 (col22)
    "sharedBlockLevelCompact", // Shared Block Paved Drive: Level and compact formation (col26)
    "sharedBlockGeotextileLayer", // Shared Block Paved Drive: Geotextile layer (col27)
    "sharedBlockSubBase", // Shared Block Paved Drive: xxxmm thick MOT Type 1 (col28)
    "sharedPermeableLevelCompact", // Shared Permeable Paving: Level and compact formation (col33)
    "sharedPermeableImpermeableGeotextileLayer", // Shared Permeable Paving: Terram Layer to Bottom and Sides permeable paving (col34)
    "sharedPermeable10to63mmCleanAggregateSubBase", // Shared Permeable Paving: xxmm thick 63-10mm Sub Base - Varied Depths (col36)
    "sharedPermeable5to20mmCleanAggregateSubBase", // Shared Permeable Paving: xxmm 5-20mm clean aggregate sub base (col37)
    "sharedPermeableGeotextileLayer", // Shared Permeable Paving: Permeable geotextile membrane (col38)
  ],
  // "Shared Drives to Binder - Timber Edgings" removed from Plot Matrix
  // (was an `["included"]` sentinel — already invisible via
  // `extractCategoryColumns`'s `isIncludedSentinel` guard; removed for
  // hygiene to keep the config aligned with the Private Drives variant
  // above).
  "Shared Drives to Binder - Edgings & Kerbs": [
    "included"
  ],
  "Shared Drives to Binder - Binder Course": [
    "sharedMacadamDbBase", // Shared Macadam Drive: xxmm DB Base (col23)
    "sharedMacadamDbBinder", // Shared Macadam Drive: xxmm DB Binder (col24)
    "sharedMacadamSealingGrit", // Shared Macadam Drive: Sealing Grit (col25)
    "sharedBlockBase", // Shared Block Paved Drive: xxmm DB Base (col29)
    "sharedBlockBinder", // Shared Block Paved Drive: xxmm DB Binder (col30)
    "sharedBlockSealingGrit", // Shared Block Paved Drive: Sealing Grit (col31)
    "sharedPermeableDbBinderRunningCourse", // Shared Permeable Paving: xxmm DB binder Running course (col35)
  ],
};

// Valuation Stage 12 & 13: Screen Walls / Retaining Walls
export const PLOT_MATRIX_SCREEN_WALLS_CATEGORIES = {
  // Screen Walls Foundation: single quantity (linear metres of screen wall) × netPerM rate
  // from Walls Section Build Up. dataIndex confirmed: screenWalls.
  // ⚠️ NOTE: no Build Up spec exists for screenWalls in wallFieldToSpecId — rate resolves to 0
  // until a screenWalls specification is added to walls-section-build-up.ts.
  "Screen Walls - upto DPC": [
    "screenWalls",
    "screenWallsEO",
    "screenWallsAdditionalExcavation",
    "screenWallsAdditionalConcrete",
  ],
  "Screen Walls - Brickwork": ["included"],
};

export const PLOT_MATRIX_RETAINING_WALLS_CATEGORIES = {
  // Retaining Walls Foundation: covers all wall type groups across both takeoff routes.
  // Part 1 individual item fields (from retainingWallsTable):
  //   screenWallsSof (SoE 450mm m), screenWallsLog (Log 1200mm m), screenWallsGravelBoard (Gravel board m)
  //   (screenWallsAdditionalExcavation/Concrete moved to "Screen Walls - upto DPC" above)
  // Part 2 wall type fields: all GRW, DRW, CCRW from retainingWallsTable;
  //   all GPCW (geoWallGPCW600, gpcw750, geoWallRW900, gpcw1050) and
  //   TPCW (tpcw1–tpcw8) from geoToberWallTable.
  // All dataIndex values confirmed from codebase column definitions.
  "Retaining Walls - Complete": [
    // Part 1 — individual screen wall item fields (retainingWallsTable)
    "screenWallsSof",
    "screenWallsLog",
    "screenWallsGravelBoard",
    // Part 2 — Garden Retaining Walls (retainingWallsTable, wallFieldToSpecId keys)
    "grw450",
    "grw600",
    "grw750",
    "grw900",
    "grw1050",
    "grw1200",
    "grw1500",
    "grw1800",
    "grw2000",
    // Part 2 — Drive Retaining Walls (retainingWallsTable, wallFieldToSpecId keys)
    "drw450",
    "drw600",
    "drw750",
    "drw900",
    "drw1050",
    "drw1200",
    "drw1500",
    "drw1800",
    "drw2000",
    "drw2250",
    "drw2500",
    "drw2750",
    "drw3000",
    // Part 2 — Concrete Core Retaining Walls (retainingWallsTable, wallFieldToSpecId keys)
    "ccrw1500",
    "ccrw1800",
    "ccrw2000",
    "ccrw2250",
    "ccrw2500",
    "ccrw2750",
    "ccrw3000",
    "ccrw3250",
    "ccrw3500",
    // Part 2 — Geowalls (geoToberWallTable, geoToberWallFieldToSpecId keys)
    "geoWallGPCW600",
    "gpcw750",
    "geoWallRW900",
    "gpcw1050",
    // Part 2 — Tobermore Walls (geoToberWallTable, geoToberWallFieldToSpecId keys)
    "tpcw1",
    "tpcw2",
    "tpcw3",
    "tpcw4",
    "tpcw5",
    "tpcw6",
    "tpcw7",
    "tpcw8",
  ],
  "Retaining Walls - Brickwork": [
    "included"
  ],
};

// Valuation Stage 14: Service Connections
// Deviation 8 — Pit Excavation is Either/Or across three mutually exclusive
// fields; priority order Plots → Apartments → Vac-ex (confirmed with business).
// All three carry distinct resource codes in `FIELD_RESOURCE_CODES`.
export const PLOT_MATRIX_SERVICE_CONNECTIONS_CATEGORIES = {
  "Service Connections - Pit Excavation": [
    "serviceConnectionPlots",
    "serviceConnectionApartments",
    "serviceConnectionVacEx",
  ],
  "Service Connections - Pit Reinstatement": ["included"],
};

// Valuation Stage 15: Plot Paving
export const PLOT_MATRIX_PLOT_PAVINGS_CATEGORIES = {
  "Plot Paving - Slab Fronts": [
    "pavingLevelCompact",
    "pavingGeotextileLayer",
    "pavingSubBase",
    "pavingPlainGreyPavings",
    "slab900wSteps",
    "slab1200wSteps",
    "slabCycleHoops",
    "slabRotaryDryer",
    // MACADAM Columns
    "macadamLevelCompact",
    "macadamGeotextileLayer",
    "macadamSubBase",
    "macadamDbBase",
    "macadamDbBinder",
    "macadamSealingGrit",
    "macadamSweepTack",
    "macadamDbSurfaceCourse",
    "macadamHraSurfaceCourse",
    "macadamSmaSurfaceCourse",
    "macadamEdgings",
  ],
  "Plot Paving - Slab Rears": ["included"],
  "Plot Paving - Threshold Drains": ["slabThresholdDrain"],
  "Plot Paving - Shed Bases": ["slabShedBase"],
  "Plot Paving - Bin Collection Points": ["included"],
  "Plot Paving - Gravel Margin/Chippings": [
    "slabGravelMarginPea",
    "slabGravelMarginCotswold",
  ],
};

// Valuation Stage 16: Topsoil/Plot Clearance
export const PLOT_MATRIX_GARDEN_CATEGORIES = {
  "Topsoil/Plot Clearance - Import Clean Cap": [
    "spreadLevelCleanSubsoilCapImported",
    "thickNoDigLayer",
    "geotextileLayer",
  ],
  "Topsoil/Plot Clearance - Place Clean Cap": [
    "spreadLevelCleanSubsoilCapSiteWon",
  ],
  "Topsoil/Plot Clearance - Import Topsoil": ["spreadLevelTopsoilImported"],
  "Topsoil/Plot Clearance - Place Topsoil": [
    "spreadLevelTopsoilSiteWon",
    "harrowGardens",
  ],
  "Topsoil/Plot Clearance - Plot Clearance": ["plotClearance"],
};

// Valuation Stage 17: Private Drives to Surface Course
export const PLOT_MATRIX_PRIVATE_DRIVES_SURFACE_CATEGORIES = {
  "Private Drives to Surface Course - Remove Timber Edging": [
    "permeableTimberEdgings",
    "macadamRemoveTimberEdgings", // Private Macadam Drive: Remove Timber edgings (col48)
  ],
  "Private Drives to Surface Course - Install PCC Edging": [
    "included"
  ],
  "Private Drives to Surface Course - Remedials": [
    "sharedPermeableEdgingRemedials",
    "sharedPermeableKerbRemedials",
  ],
  "Private Drives to Surface Course - Adjust Ironworks": [
    "sharedPermeableAdjustIronwork",
    "sharedPermeableDriveDemo",
  ],
  "Private Drives to Surface Course - Punture Binder Block Paving": [
    "blockPunctureMacadam",
    "permeablePunctureMacadam",
    "sharedBlockPunctureMacadam",
    "sharedPermeablePunctureMacadam",
  ],
  "Private Drives to Surface Course - Final Surfacing": [
    "sharedPermeableRecessedCF",
    "macadamTack",
    "macadamDbSurfaceCourse",
    "macadamHraSurfaceCourse",
    "macadamSmaSurfaceCourse",
    "blockSweep",
    "blockLayingCourse",
    "block60mmConcrete",
    "block80mmConcrete",
    "permeable2to6mmLayingAggregate",
    "permeable60mmConcrete",
    "permeable80mmConcrete",
  ],
};

// Valuation Stage 18: Shared Drives to Surface Course
export const PLOT_MATRIX_SHARED_DRIVES_SURFACE_CATEGORIES = {
  "Shared Drives to Surface Course - Remove Timber Edging": [
    "included",
  ],
  "Shared Drives to Surface Course - Install PCC Edging": [
    "included"
  ],
  "Shared Drives to Surface Course - Remedials": [
    "included"
  ],
  "Shared Drives to Surface Course - Adjust Ironworks": [
    "included"
  ],
  "Shared Drives to Surface Course - Punture Binder Block Paving": [
    "included"
  ],
  "Shared Drives to Surface Course - Final Surfacing": [
    "sharedMacadamSweepTack",
    "sharedMacadamDbSurfaceCourse",
    "sharedMacadamHraSurfaceCourse",
    "sharedMacadamSmaSurfaceCourse",
    "sharedBlockLayingCourse",
    "sharedBlock60mmConcrete",
    "sharedBlock80mmConcrete",
    "sharedPermeable2to6mmLayingAggregate",
    "sharedPermeable60mmConcrete",
    "sharedPermeable80mmConcrete",
  ],
};

// Combine all categories in the correct order for Cut & Fills step
const PLOT_MATRIX_CUT_FILL_ALL_CATEGORIES = {
  ...PLOT_MATRIX_SITE_STRIP_CATEGORIES,
  ...PLOT_MATRIX_CUT_FILL_CATEGORIES,
};

// Combine all categories in the correct order for Foundations step
const PLOT_MATRIX_FOUNDATION_ALL_CATEGORIES = {
  ...PLOT_MATRIX_PILE_MATTS_CATEGORIES,
  ...PLOT_MATRIX_FOUNDATION_EXC_CONC_CATEGORIES,
  ...PLOT_MATRIX_FOUNDATION_WALLS_DPC_CATEGORIES,
  ...PLOT_MATRIX_FOUNDATION_FLOOR_CATEGORIES,
};

// Combine all categories for Plot Drives step
const PLOT_MATRIX_PLOT_DRIVES_ALL_CATEGORIES = {
  ...PLOT_MATRIX_PRIVATE_DRIVES_BINDER_CATEGORIES,
  ...PLOT_MATRIX_SHARED_DRIVES_BINDER_CATEGORIES,
};

// Combine all categories for Ret & Screen Walls step
const PLOT_MATRIX_RET_SCREEN_WALLS_ALL_CATEGORIES = {
  ...PLOT_MATRIX_SCREEN_WALLS_CATEGORIES,
  ...PLOT_MATRIX_RETAINING_WALLS_CATEGORIES,
};

// Map of step names to their Plot Matrix specific categories
// These step names MUST match the names used in plotMatrixCategoryGenerator.ts
export const PLOT_MATRIX_STEP_CATEGORIES: {
  [stepName: string]: { [categoryName: string]: string[] } | null;
} = {
  "Cut & Fills": PLOT_MATRIX_CUT_FILL_ALL_CATEGORIES,
  Foundations: PLOT_MATRIX_FOUNDATION_ALL_CATEGORIES,
  Scaffold: PLOT_MATRIX_SCAFFOLD_CATEGORIES,
  Drainage: PLOT_MATRIX_DRAINAGE_CATEGORIES,
  "Plot Service": PLOT_MATRIX_PLOT_SERVICE_CATEGORIES,
  "Plot Drives": PLOT_MATRIX_PLOT_DRIVES_ALL_CATEGORIES,
  "Ret & Screen Walls": PLOT_MATRIX_RET_SCREEN_WALLS_ALL_CATEGORIES,
  "Service Connections": PLOT_MATRIX_SERVICE_CONNECTIONS_CATEGORIES,
  "Plot Pavings": PLOT_MATRIX_PLOT_PAVINGS_CATEGORIES,
  Garden: PLOT_MATRIX_GARDEN_CATEGORIES,
  "Private Drives Surface": PLOT_MATRIX_PRIVATE_DRIVES_SURFACE_CATEGORIES,
  "Shared Drives Surface": PLOT_MATRIX_SHARED_DRIVES_SURFACE_CATEGORIES,
  // 'Geowall & Tobermore Walls': GEO_TOBER_WALL_CATEGORIES, // Excluded - not required in Plot Matrix
};
